(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('CompanyCustomerFormDataReportCustom', CompanyCustomerFormDataReportCustom);

    CompanyCustomerFormDataReportCustom.$inject = ['$resource', 'ENV'];

    function CompanyCustomerFormDataReportCustom($resource, ENV) {

        var searchCompanyCustomerFormDataReportByQueryPage = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/search-company-customer-form-data-report-page';
            return $resource(resourceUrl, {}, {
                    'save': {method: 'POST', isArray: true}
                }
            );
        };

        var getCompanyCustomerFormDataById = function (id) {

            var resourceUrl = ENV.API_BASE_URL + 'api/get-company-custom-form-data-by-id/' + id;
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: false}
                }
            );
        };


        return {


            searchCompanyCustomerFormDataReportByQueryPage: searchCompanyCustomerFormDataReportByQueryPage,
            getCompanyCustomerFormDataById: getCompanyCustomerFormDataById

        };
    }
})();
